import { styled } from '@mui/material/styles';
import { DialogActions, DialogContent, DialogContentText, Paper, Dialog } from '@mui/material';

const StyledDialog = styled(Dialog)(
  ({ theme }) => `
  & .MuiDialog-paper {
  width: 100%;
  }
    ${theme.breakpoints.up('md')} {
     width: fit-content;
     margin: 0 auto;
    }
    
  `,
);

const StyledPaper = styled(Paper)(
  ({ theme }) => `
    border-radius: ${theme.DS_border.radius.priceCard};
    padding: ${theme.DS_spacing(['md'])};
    background-color: ${theme.DS_palette.primary.white};

    ${theme.breakpoints.up('md')} {
       padding: ${theme.DS_spacing(['lgx'])};
       width: calc(100% - ${theme.DS_spacing(['lgx'])} *2);
    }
  `,
);

const StyledDialogContent = styled(DialogContent)(
  () => `
   &.MuiDialogContent-root {
        padding: 0;
    }
  `,
);

const StyledDialogContentText = styled(DialogContentText)(
  ({ theme }) => `
    color: ${theme.DS_palette.primary.black};
    margin-bottom: ${theme.DS_spacing(['xxs'])};
    & .MuiDialogContent-root {
      padding: 0;
    }
  `,
);

const StyledDialogActions = styled(DialogActions)(
  ({ theme }) => `
 
    flex-direction: column-reverse;
    gap: ${theme.DS_spacing(['xxs'])};
    padding: 0;
   
    button {
        width: 100%;
       &:not(:first-of-type) {
       margin-left: 0;
       }
     
    }


    ${theme.breakpoints.up('md')} {
      flex-direction: row;
      justify-content: flex-start;
        button {
        width: inherit;
    }
    }
  `,
);

export { StyledPaper, StyledDialogContent, StyledDialogContentText, StyledDialogActions, StyledDialog };
